/**
 * Created by cedricgodefroy on 23/08/2017.
 */
angular.module('FlexyBeautyApp.services').factory('PeriodStat', ["PeriodType", "DayData", "gettextCatalog", "moment", function (PeriodType, DayData, gettextCatalog, moment) {
    var PeriodStat = function (type, beginMomentDay, endMomentDay, periodType) {
        this.type = type;

        this.beginMomentDay = beginMomentDay;
        this.endMomentDay = endMomentDay;

        this.periodType = periodType;

        this.arrayOfDays = null;
        this.loadArrayOfDays();
    };

    PeriodStat.prototype.getArrayOfDays = function () {
        return this.arrayOfDays;
    };

    PeriodStat.prototype.loadArrayOfDays = function () {
        var arrayOfDays = new Array();

        var currentMomentDay = this.beginMomentDay.clone();

        while (this.endMomentDay.diff(currentMomentDay) >= 0) {

            var dayId = currentMomentDay.format("YYYYMMDD"),
                //myDay = DaySrv.getByIdAdder(dayId,true);
                myDay = DayData.getById(dayId);

            if (myDay) {
                arrayOfDays.push(myDay);
            }
            currentMomentDay.add(1, 'day');
        }

        this.arrayOfDays = arrayOfDays;
    };

    PeriodStat.prototype.getLabel = function () {
        var formator = null,
            labelPeriod = null;
        if (this.periodType != PeriodType.CUSTOMED) {
            if (this.periodType === PeriodType.DAY) {
                formator = "dddd L";
            } else if (this.periodType === PeriodType.WEEK) {
                var weekFormat = gettextCatalog.getString("Semaine du");
                formator = "[" + weekFormat + "] L";
            } else if (this.periodType === PeriodType.MONTH) {
                formator = "MMMM YYYY";
            } else if (this.periodType === PeriodType.YEAR) {
                formator = "YYYY";
            }
            labelPeriod = this.beginMomentDay.format(formator);
        } else {
            formator = "DD/MM/YYYY";
            labelPeriod = "Du " + this.beginMomentDay.format(formator) + " au " + this.endMomentDay.format(formator);
        }
        return labelPeriod;
    };

    PeriodStat.prototype.getLabelBegin = function () {
        var formator = formator = "dddd L";

        return this.beginMomentDay.format(formator);
    };

    PeriodStat.prototype.getLabelEnd = function () {
        var formator = "dddd L",
            labelEnd = '';
        if (this.arrayOfDays && this.arrayOfDays.length > 0) {
            labelEnd = this.arrayOfDays[this.arrayOfDays.length - 1].getMomentDate().format(formator);
        } else {
            labelEnd = this.endMomentDay.format(formator);

        }
        return labelEnd;
    };

    PeriodStat.prototype.isSame = function (otherPeriodStat) {
        return (this.type === otherPeriodStat.type &&
            this.beginMomentDay.isSame(otherPeriodStat.beginMomentDay) &&
            this.endMomentDay.isSame(otherPeriodStat.endMomentDay) &&
            this.periodType === otherPeriodStat.periodType);
    };

    PeriodStat.getLastYearCorrespondingDay = function (momentDay, timePeriod) {
        var momentLastYear = null;
        if (momentDay) {
            if (timePeriod === PeriodType.DAY || timePeriod === PeriodType.WEEK || timePeriod === PeriodType.CUSTOMED) {
                var year = momentDay.year();
                var weekNumber = momentDay.isoWeek();
                var dayNumber = momentDay.isoWeekday();

                momentLastYear = (new moment()).year(year - 1).isoWeek(weekNumber).isoWeekday(dayNumber).startOf('day');
            } else if (timePeriod === PeriodType.MONTH || timePeriod === PeriodType.YEAR) {
                momentLastYear = momentDay.subtract(1, 'year').startOf('day');
            }
        }
        return momentLastYear;
    };

    PeriodStat.prototype.getNbDaysDuration = function () {
        return this.endMomentDay.diff(this.beginMomentDay, 'days')
    };

    return PeriodStat;

}])



// WEBPACK FOOTER //
// ./js/services/views/statistics/report/PeriodStat.js